// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__WgXf4","inner":"styles_inner__6vRx0","mark":"styles_mark__9e4V_","avail":"styles_avail__opYp6","dot":"styles_dot__g5r8_"};